module.exports = __webpack_public_path__ + "static/media/18.113be5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/18.png
// module id = 655
// module chunks = 0